//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import CustomStore from 'devextreme/data/custom_store';
import { environment } from 'src/environments/environment';
import { eSimApiPaths } from 'src/app/core/consts';
import { ExceptionsService } from '../../general/exceptions-service';
import { HttpClientService } from '../../general/http-client-service';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { Injectable } from '@angular/core';
import { Observable, lastValueFrom, map, of } from 'rxjs';
import { TypeChargeDTO } from 'src/app/core/models/system/type/type-charge.dto';

@Injectable({ providedIn: 'root' })

export class TypesChargeService {
  
  constructor(
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }

  public getIdAndDescription(): Observable<IdAndDescriptionDTO[]> {
    try {
      return this.httpClientService.get<TypeChargeDTO[]>(environment.eSimApi + eSimApiPaths.TypesCharge)
      .pipe(
        map(x => x.map(this.idAndDescriptionConverter))
      );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  private idAndDescriptionConverter(typeCharge: TypeChargeDTO) {
    return {id: typeCharge.id, description: typeCharge.chargeType};
  }

  public idAndDescriptionLookupDataSource(): {} {
    try {
      return {
        store: new CustomStore({
          key: "id",
          loadMode: "raw",
          load: () => {
            return lastValueFrom(this.getIdAndDescription());
          }
        }),
        sort: "description"
    };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return {};
    }
  }
}
